import { Grid, Icon, Link, useIsTheme, Theme, Text } from '@afterpaytouch/core'
import React, { FC } from 'react'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import { Trans } from '..'
import { Wrapper } from '../Wrapper'
import styles from './style.module.css'

interface Props {
  clickHandler: () => void
}

export const ResendInstructions: FC<Props> = ({ clickHandler }) => {
  const isCashTheme = useIsTheme(Theme.Cash)
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()

  if (isCashTheme) {
    return (
      <>
        <Wrapper>
          <Grid>
            <Text size={textSize} color='Subtle'>
              <Trans
                i18nKey={'passwordResetRequired:sendAgain'}
                components={{
                  a: <Link onClick={clickHandler} kind={'Underline'} color='Prominent' />,
                }}
              />
            </Text>
          </Grid>
        </Wrapper>
        <div className={styles.spacer}></div>
      </>
    )
  }

  return (
    <>
      <Wrapper>
        <Grid>
          <Text size={textSize} bold>
            {t('passwordResetRequired:secondaryBody')}
          </Text>
        </Grid>
      </Wrapper>
      <Grid>
        <Text size={textSize}>
          <Icon.Trash />
          <span className={styles.ml4}>{t('passwordResetRequired:trash')}</span>
        </Text>
      </Grid>
      <Wrapper>
        <Grid>
          <Text size={textSize}>
            <Icon.Email />
            <span className={styles.ml4}>
              <Trans
                i18nKey={'passwordResetRequired:sendAgain'}
                components={{
                  a: <Link onClick={clickHandler} kind={'Underline'} />,
                }}
              />
            </span>
          </Text>
        </Grid>
      </Wrapper>
      <div className={styles.mt8}></div>
    </>
  )
}
